@if (organization) {
@if (organization.summary?.SEC_CIK) {

<ul ngbNav #nav="ngbNav" [(activeId)]="activeId" class="nav nav-underline mx-2 position-sticky top-0 bg-body z-3" [destroyOnHide]="false" (activeIdChange)="sendAnalyticsForTabChange($event)">
    @for (tab of tabs; track tab) {
    <li [ngbNavItem]="tab[0]">
        <button ngbNavLink>
            {{ tab[1] }}
        </button>
        <ng-template ngbNavContent>
            @if (tab[0] === 'overview' ) {

            <ng-container *ngTemplateOutlet="overviewContent; context: {$implicit: organization}"></ng-container>

            } @else {
            @if (tab[0] === 'documentssec' ){
            @defer (on viewport) {

            <sec-documents-viewer [requiredFilters]="{cik: organization.summary.SEC_CIK, name: organization.name, embedded: true}" [documentSearchOptionGroups]="documentSearchOptions" class="d-block mx-3" [embedded]="true"
                [initialSearch]="{ parameters: documentInitialSearch, order: {column: 'itemupdatedat', direction: 'desc'}}" contentSet="secdocuments"></sec-documents-viewer>
            } @placeholder {
            <div class="preview-placeholder">
                Loading...
            </div>
            }

            } @else {
            <!-- financial-statement [secCIK]="organization.summary.SEC_CIK" [tag]="tab[0]"></!-->
            }
            }
        </ng-template>
    </li>
    }
</ul>

<div [ngbNavOutlet]="nav" class="mt-2"></div>

} @else {
<ng-container *ngTemplateOutlet="overviewContent; context: {$implicit: organization}"></ng-container>
}
}

<ng-template #overviewContent let-organization>
    <div class="row m-2" id="top">
        <div class="col">
            <div [innerHTML]="organization.summary?.profile"></div>
            @if (organization['summary']?.company_type) {
            <div class="col-md-6">Company Type: {{organization['summary'].company_type}}</div>
            }
            @if (organization['summary']?.market_tickers) {
            <div class="col-md-6">Tickers: {{organization['summary'].market_tickers}}</div>
            }
            @if (usableContactInformation(organization['contact_details']?.contacts)) {
            <div class="col-md-6">
                @if (organization['contact_details']?.contacts; as contact) {

                Contact:
                <ul class="list-unstyled">
                    @if (contact.email) {
                    <li><a target="_blank" [href]="'mailto:' + contact.email">{{contact.email}}</a></li>
                    }
                    @if (contact.telephone) {
                    <li><a target="_blank" [href]="'tel:' + contact.telephone">{{contact.telephone}}</a></li>
                    }
                    @if (contact.web) {
                    <li><a target="_blank" [href]="contact.web">Website</a></li>
                    }
                    @if (contact.Other) {
                    <li>{{contact.Other}}</li>
                    }
                    @if (contact.linkedin?.length > 10) {
                    <li>
                        <a target="_blank" href="{{contact.linkedin}}" [ngbPopover]="linkedIn" [popoverContext]="{linkedin : getLinkedInHandle(contact.linkedin)}" popoverClass="linkedin-popover" triggers="mouseenter" [autoClose]="'outside'"
                            [openDelay]="200">
                            <i-bs [name]="iconNames.Linkedin"></i-bs>&nbsp;LinkedIn
                        </a>
                    </li>
                    }
                </ul>

                }
            </div>
            }
        </div>
        <div class="col-auto">
            @if (addAppHeader) {
            <app-header class="__header" [showBack]="true" [article]="organizationArticle!" [title]="''" [backRoute]="'..'" [contentSet]="'organizations'" [followOptions]="followOptions"></app-header>
            }
        </div>
    </div>
    @if (organization['contact_details']; as contactDetails) {
    <div class="row m-2">
        @if (contactDetails.locations?.length) {
        <div class="col-md-6">
            <h2>Locations</h2>
            <table class="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Address</th>
                    </tr>
                </thead>
                <tbody>
                    @for (location of contactDetails.locations; track location) {
                    <tr>
                        <td>
                            <strong>{{ location.name }}</strong>
                        </td>
                        <td>
                            <ul class="list-unstyled">
                                @if (location.address_line_1) {
                                <li>{{ location.address_line_1 }}</li>
                                }
                                @if (location.address_line_2) {
                                <li>{{ location.address_line_2 }}</li>
                                }
                                @if (location.city) {
                                <li>{{ location.city }}</li>
                                }
                                @if (location.state) {
                                <li>{{ location.state }}</li>
                                }
                                @if (location.zip) {
                                <li>{{ location.zip }}</li>
                                }
                                @if (location.country) {
                                <li>{{ location.country }}</li>
                                }
                            </ul>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        }
        @if (organization['company_officers']?.length ||
        organization['people']?.length ||
        organization['children']?.length ||
        organization['parents']?.length||
        organization['investor_relations']?.organization?.length||
        organization['auditors']?.length) {
        <div class="col-md-6">
            @if (organization['parents']?.length) {

            <h2 id="situations">Parent organizations</h2>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Parent Name</th>
                        <th>Role</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                    </tr>
                </thead>
                <tbody>
                    @for (aparent of organization['parents']; track aparent) {
                    <tr>
                        <td>
                            <a [routerLink]="'/organizations/' + aparent.entity_id">{{aparent.entity_name}}</a>
                        </td>
                        <td>
                            {{aparent.relation}}
                        </td>
                        <td>
                            @if (aparent.startDate?.length === 10 && aparent.startDate != '0000-00-00') {
                                {{aparent.startDate}}
                            }
                        </td>
                        <td>
                            @if (aparent.endDate?.length === 10 && aparent.endDate != '0000-00-00') {
                                {{aparent.endDate}}
                            }
                        </td>
                    </tr>
                    }
                </tbody>
            </table>

            }
            @if (organization['children']?.length) {

            <h2 id="subsidiaries">Affiliates/Subsidiaries</h2>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Role</th>
                        <!-- <th>Start Date</th>
                                <th>End Date</th> -->
                    </tr>
                </thead>
                <tbody>
                    @for (achild of organization['children']; let i = $index; track achild) {
                    <tr [class.d-none]="!showAllChildren && i >= 10">
                        <td>
                            <a [routerLink]="'/organizations/' + achild.entity_id">{{achild.entity_name}}</a>
                        </td>
                        <td>
                            {{achild.relation}}
                        </td>
                        <!--
                                <td>
                                    {{achild.startDate}}
                                </td>
                                <td>
                                    {{achild.endDate}}
                                </td>
                            -->
                    </tr>
                    }
                    @if (organization['children'].length > 10) {
                    <tr>
                        <td colspan="5" class="py-2">
                            <button type="button" class="btn btn-outline-dark btn-sm" (click)="showAllChildren = !showAllChildren">
                                @if (!showAllChildren) {

                                Show All ({{organization['children'].length}})

                                }
                                @if (showAllChildren) {

                                Hide

                                }
                            </button>
                        </td>
                    </tr>
                    }

                </tbody>
            </table>

            }
            @if (organization['auditors']?.length) {

            <h2 id="situations">Auditors</h2>
            <ul class="list-unstyled">
                @for (auditor of organization['auditors']; track auditor) {
                <li>
                    <a [routerLink]="'/organizations/' + auditor.entity_id">{{ auditor.name }}</a>
                </li>
                }
            </ul>

            }
            @if (organization['investor_relations']?.organization?.length) {

            <h2 id="situations">Investor Relations</h2>
            <ul class="list-unstyled">
                @for (ir of organization['investor_relations'].organization; track ir) {
                <li>
                    <a [routerLink]="'/organizations/' + ir.entity_id">{{ ir.entity_name }}</a>
                </li>
                }
            </ul>

            }

            @if (organization['company_officers']?.length) {
            <div class="row m-2">
                <div class="col">
                    <h2 id="company_officers">Company Officers</h2>
                    @for (officer of organization['company_officers']; track officer) {
                    <ul class="list-unstyled">
                        <li><a target="_blank" [routerLink]="'/people/' + officer.entity_id" target="_blank">{{ officer.entity_name }} - {{ officer.relation }}</a></li>

                    </ul>
                    }
                </div>
            </div>
            }
        </div>
        }

        @if (organization['people']?.length) {
        <div class="row m-2">
            <div class="col">
                <h2 id="situations">Staff ({{organization['people']?.length}})</h2>
                <auto-filter-table [data]="organization['people']" [columns]="staffTableColumns"></auto-filter-table>
            </div>
        </div>
        }
    </div>
    }
    @if (organization['timeline']?.length) {
        <div class="row m-2">
            <div class="col">
            <situation-timeline [timeline]="organization['timeline']" [expandAllDistressed]="true">
                <h2 id="situations">Situations</h2>
            </situation-timeline>
            </div>
        </div>
    }

    @if (organization['creditorpositions']?.length) {
    <div class="row m-2">
        <div class="col">
            <h2 id="situations">
                Trade Exposure
                @if (creditorMode && showMatchedLabels) {
                    <button class="btn btn-outline-bankruptcydata" (click)="toggleShowAllCreditorPosition()">{{creditorFilterButtonText}}</button>
                }
            </h2>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Case Date</th>
                        <th>Case Name</th>
                        <th>Form</th>
                        <th>Address &amp; Contact</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    @for (asituation of organization['creditorpositions']; track asituation) {
                    @if (!creditorMode || showAllInCreditorMode || asituation.matched) {
                    <tr>
                        <td>
                            {{asituation.case_filing_date | date}}
                        </td>
                        <td>
                            <a href="/situations/{{asituation.caseArticleID}}">{{asituation.case_name}}</a>
                            @if (showMatchedLabels && creditorMode && !showAllInCreditorMode && asituation.matched) {
                                &nbsp;&nbsp;<span class="badge rounded-pill bg-success">Matched</span>
                            }
                        </td>
                        <td>
                            @if (asituation.form == 'unknown') {

                            } @else {
                                @let document = getCreditorFormFromPetition(asituation.form, asituation.petitionStructure, asituation.petitionPDF) ;
                                @if (document) {
                                    <pdf-viewer [document]="document">
                                        <ng-container *ngTemplateOutlet="friendlyFormName; context: {creditor: asituation}"></ng-container>
                                    </pdf-viewer>
                                } @else {
                                    <ng-container *ngTemplateOutlet="friendlyFormName; context: {creditor: asituation}"></ng-container>
                                }
                            }
                        </td>
                        <td>
                            <div class="row">

                            @if (asituation.creditorAddress_address1.length > 1) {
                                <address class="col">
                                    {{asituation.creditorAddress_address1}}<br>
                                    @if (asituation.creditorAddress_address2.length > 1) {
                                        {{asituation.creditorAddress_address2}}<br>
                                    }
                                    {{asituation.creditorAddress_city}}<br>
                                    {{asituation.creditorAddress_state}} {{asituation.creditorAddress_zip}} {{asituation.creditorAddress_country}} <br>
                                </address>
                                <ul class="list-unstyled col">
                                    @if (asituation.contactName) {
                                        <li>{{asituation.contactName}}</li>
                                    }
                                    @if (asituation.contactEmail) {
                                        <li><a target="_blank" [href]="'mailto:' + asituation.contactEmail">{{asituation.contactEmail}}</a></li>
                                    }
                                    @if (asituation.contactLinkedIn) {
                                        <li>
                                            <a target="_blank" href="{{asituation.contactLinkedIn}}" [ngbPopover]="linkedIn" [popoverContext]="{linkedin : getLinkedInHandle(asituation.contactLinkedIn)}" popoverClass="linkedin-popover" triggers="mouseenter" [autoClose]="'outside'"
                                                [openDelay]="200">
                                                <i-bs [name]="iconNames.Linkedin"></i-bs>&nbsp;LinkedIn
                                            </a>

                                    }
                                    @if (asituation.contactTelephone) {
                                        <li><a target="_blank" [href]="'tel:' + asituation.contactTelephone">Tel: {{asituation.contactTelephone}}</a></li>
                                    }
                                    @if (asituation.contactFax) {
                                        <li><a target="_blank" [href]="'tel:' + asituation.contactFax">FAX: {{asituation.contactFax}}</a></li>
                                    }

                                </ul>
                            }
                        </div>
                        </td>
                        <td>
                            {{(asituation.totalClaimAmount ?? asituation.unsecuredClaimAmount ) | currency }}
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>
        </div>
    </div>
    }

    @if (organization['involvements']?.length) {
    <div class="row m-2">
        <div class="col">
            <h2 id="situations">Involvements</h2>
            <auto-filter-table [data]="organization['involvements']" [columns]="involvementTableColumns"></auto-filter-table>
        </div>
    </div>
    }
    @if (organization['retentions']?.length) {
    <div class="row m-2">
        <div class="col">
            <h2 id="retentions">Retentions</h2>
            <auto-filter-table [data]="organization['retentions']" [columns]="retentionsTableColumns" [canExpand]="false"></auto-filter-table>
        </div>
    </div>
    }

    @if (organization?.capital_structure?.prepetitionCapitalStructure?.length) {
        <div class="row m-2">
            <div class="col">
                <h2 id="instruments">Capital Structure</h2>
                    <prepost-capital-structure [structure]="organization.capital_structure.prepetitionCapitalStructure" [columns]="organization.capital_structure.prepetitionCapitalStructure_columns" [instrumentIDLookup]="organization.instrumentIDLookup" [classesLookup]="{}" [expandID]="''" [showExpiredControl]="true"></prepost-capital-structure>
            </div>
        </div>
    }

    @if (organization['linked_instruments']?.length) {
    <div class="row m-2">
        <div class="col">
            <h2 id="instruments">Involved Instruments</h2>
            <auto-filter-table [data]="organization['linked_instruments']" [columns]="linkedInstrumentsTableColumns" [canExpand]="true" [expansionTemplate]="holdingsExpansion"></auto-filter-table>
        </div>
    </div>
    }
    @if (organization['holdings']?.length) {
    <div class="row m-2">
        <div class="col">
            <h2 id="holdings">Holdings</h2>
            <auto-filter-table [data]="organization['holdings']" [columns]="holdingsTableColumns" [canExpand]="true" [expansionTemplate]="holdingsExpansion"></auto-filter-table>
        </div>
    </div>
    }
    @if (organization['linked']?.instruments?.length) {
    <div class="row m-2">
        <div class="col">
            <h2 id="situations">Instruments</h2>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Instrument Involvement</th>
                        <th>Case Name</th>
                        <th>Instrument Name</th>
                    </tr>
                </thead>
                <tbody>
                    @for (ainstrument of organization['linked'].instruments; track ainstrument) {
                    <tr>
                        <td>
                            {{ainstrument.attributeName}}
                        </td>
                        <td>
                            <a [routerLink]="'/situations/'+ ainstrument.case_ArticleID">{{ainstrument.case_name}}</a>
                        </td>
                        <td>
                            {{ainstrument.instrument_name}}
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    }
    @if (hasLinkedPlans(organization['linked_plans'])) {
    <div class="row m-2">
        <div class="col">
            <h2 id="plans">Plans</h2>
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>Plan Involvement</th>
                        <th>Case Name</th>
                        <th>Plan Name</th>
                    </tr>
                </thead>
                <tbody>
                    @for (plans of organization['linked_plans'] | keyvalue; track plans) {

                    @for (aplan of $any(plans.value); track aplan) {
                    <tr>
                        <td>
                            {{aplan.attributeName}}
                        </td>
                        <td>
                            <a [routerLink]="'/situations/'+ aplan.case_ArticleID">{{aplan.case_name}}</a>
                        </td>
                        <td>
                            <a [routerLink]="'/data/plans/'+ aplan.articleID">{{aplan.plan_name}}</a>
                        </td>
                    </tr>
                    }

                    }
                </tbody>
            </table>
        </div>
    </div>
    }
    @if (organization['news_articles']?.length) {
    <div class="row m-2">
        <div class="col">
            <h2 id="news">News</h2>
            <ul class="list-group list-group-flush w-100">
                @for (article of organization['news_articles']; let i = $index;; track article) {

                <li class="list-group-item article-display">
                    <div [libMasterRouterLink]="['news' , article.id]" [queryParams]="getQueryParams(organization.articleID, organization.name)">
                        <app-list-item [article]="article" [isSelected]="false" [showAttributes]="false" [dateFormat]="'medium'"></app-list-item>
                    </div>
                </li>

                }
            </ul>
            <button class="btn btn-gradient d-block" style="margin: 0 auto" [libMasterRouterLink]="['news']" [queryParams]="getQueryParams(organization.articleID, organization.name)">Show all news for {{ organization.name }}</button>
        </div>
    </div>
    }
</ng-template>

<ng-template #linkedIn let-linkedin="linkedin">
    <linked-in [handle]="linkedin"></linked-in>
</ng-template>

<ng-template #holdingsExpansion let-row="row">
    <table class="table">
        <thead>
            <tr>
                <th>
                    Date
                </th>
                <th>
                    Position
                </th>
                <th>
                    Value
                </th>
            </tr>
        </thead>
        <tbody>
            @for (holding of row.expansion; track holding) {
            <tr>
                <td>{{ holding.holdingDate | date}} </td>
                <td>{{ holding.position }}</td>
                <td>
                    {{ holding.holdingValue }}
                    @if (holding.other_instruments.length) {
                    <div>
                        Held with:
                        <ul class="comma-list">
                            @for (instrument of holding.other_instruments; track instrument) {
                            <li>
                                {{ instrument.instrument_name }}
                            </li>
                            }
                        </ul>
                    </div>
                    }
                </td>
            </tr>
            }
        </tbody>
    </table>
</ng-template>

<ng-template #friendlyFormName let-creditor="creditor">
    @switch (creditor.form) {
    @case ('form206ef') {
    Form 206/EF
    }
    @case ('form204') {
    Form 204
    }
    @case ('form206d') {
    Form 206D
    }
    }
</ng-template>

<adobe-pdf-viewer></adobe-pdf-viewer>
